import { FileFormFieldProps } from '../../types';
import { TextInput, Dropdown, DateInput, DateTimeInput } from 'qubCommon/Inputs';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect, useState } from 'react';

const FileFormField = (props: FileFormFieldProps) => {
    const { type, options = [], isReadOnly, name, ...other } = props;
    const { getValues, unregister, setValue } = useFormContext();
    const [isHidden, setIsHidden] = useState(false);
    const watchCommon = useWatch({ name: 'common' });

    useEffect(() => {
        if (name === 'dateTo') {
            if (watchCommon === 43) {
                setValue('dateTo', null);
                unregister('dateTo');
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
        }
    }, [watchCommon, name, unregister]);

    // todo - make this dynamic
    if (isHidden) return null;

    switch (type) {
        case 'string':
            return <TextInput name={name} disabled={isReadOnly} defaultFromProps={false} {...other} />;
        case 'dropdown':
            return <Dropdown name={name} disabled={isReadOnly} options={options} {...other} />;
        case 'date':
            return (
                <>
                    {!isHidden && (
                        <DateInput
                            name={name}
                            blurFn={undefined}
                            tooltip={undefined}
                            defaultFromProps={false}
                            disabled={isReadOnly}
                            {...other}
                        />
                    )}
                </>
            );
        case 'datetime':
            return (
                <DateTimeInput
                    name={name}
                    blurFn={undefined}
                    tooltip={undefined}
                    defaultFromProps={false}
                    disabled={isReadOnly}
                    {...other}
                />
            );
        default:
            return null;
    }
};

export default FileFormField;
